<div class="flex flex-col gap-1">
  <div class="grid grid-cols-2 gap-1">
    <span>{{ title() | transloco }}</span>
    <div class="w-full flex justify-end text-primary-accumin-black-50 text-p1b">
      {{ subtitle() | transloco }}
    </div>
  </div>
  <div class="grid grid-cols-2 gap-1">
    <span>{{ "Properties.Units.YearSingle" | transloco }}</span>
    <div class="w-full flex justify-end text-primary-accumin-black-50 text-p1b">
      {{ objectInformation().ConstructionYear }}
    </div>
  </div>
  <div class="grid grid-cols-2 gap-1">
    <span>{{ "Module.ObjectInformation.LivingSpace" | transloco }}</span>
    <div class="w-full flex justify-end text-primary-accumin-black-50 text-p1b"> {{ objectInformation().LivingSpace }} m² </div>
  </div>
</div>

<mat-divider class="!my-2" />

<div class="flex flex-col justify-center items-center py-1 my-1 bg-primary-accumin-black-05 rounded-lg w-full">
  <span class="!m-0 !y-0 text-p2b">
    {{ priceTitle() }}
  </span>
  <h4 class="!m-0 !y-0">
    {{ priceValue() | translocoDecimal: { minimumFractionDigits: 0, maximumFractionDigits: 0 } }}
  </h4>
</div>
